export const zhTW = {
    common: {
        publish: "发布",
        operation: "操作",
        backToList: "返回列表",
        submit: "提交",
        enabled: "启用",
        disable: "禁用",
        open: "开",
        close: "关",
        yes: "是",
        no: "否",
        quickCreate: "快速创建",
        delete: "删除",
        revoke: "撤回",
        adjust: "调整",
        approve: "审核",
        reject: "拒绝",
        pass: "通过",
        pleaseInput: "请填写",
        pleaseSelect: "请选择",
        pleaseUpload: "请上传",
        query: "查询",
        reset: "重置",
        create: "新建",
        modify: "编辑",
        detail: "详情",
        save: "保存",
        view: "查看",
        confirm: "确定",
        cancel: "取消",
        nullify: "作废",
        please: "请",
        download: "下载",
        upload: "上传",
        description: "描述",
        deleteItem: "确认删除该项吗？",
        deleteItems: "是否确认删除已选中的？",
        deleteSuccess: "删除成功！",
        nullifyItem: "确认作废该项吗？",
        nullifySuccess: "作废成功！",
        isSubmit: "是否确认提交？",
        isPublish: "是否确认发布？",
        isApprove: "是否确认审核通过？",
        isReject: "是否确认拒绝？",
        batchOperation: "批量操作",
        enabledSuccess: "启用成功",
        disableSuccess: "禁用成功",
        createSuccess: "创建成功",
        synchronizeSuccess: "同步成功",
        approveSuccess: "审批成功",
        modifySuccess: "修改成功",
        operateSuccess: "操作成功",
        all: "全部",
        sync: "同步",
        fiscalYear: "财年",
        previous: "上一步",
        next: "下一步",
        useTips: "使用说明",
        allow: "允许",
        forbidden: "禁止",
        draft: "草稿",
        saveDraft: "保存草稿",
        send: "发送",
        inReview: "审批中",
        approved: "已审批",
        rejected: "审批拒绝",
        status: "状态",
        recall: "撤回",
        attachment: "附件",
        submited: "已提交",
        selectAll: "全选",
        batchDelete: "批量删除",
        rmb: "元",
        rejectReason: "拒绝原因",
        collapse: "折叠",
        expand: "展开",
        downloadTemplate: "下载模板",
        uploadData: "上传数据",
        batchUpload: "批量上传数据",
        unit: "单位",
        export: "导出",
        exportData: "导出数据",
        import: "导入",
        importData: "导入数据",
        uploadSuccess: "上传成功",
        apply: "应用",
        day: "天",
        refresh: "刷新",
        refreshSuccess: "刷新成功！",
        sort: "排序"
    },
    component: {
        header: {
            loginOut: "退出登录",
            toggleZh: "中文",
            toggleEn: "English",
            cnZH: "简体中文",
            cnTW: "繁体中文",
            enUS: "English",
			jap: "日本語",
			kr: "한국어",
			my: "Bahasa Melayu",
			th: "ภาษาไทย",
			es: "español",
			ind: "हिंदी",
			ar: "العربية",
			de: "Das ist Deutsch.",
			la: "En français",
			turk: "Türkçe",
			vn: "Tiếng Việt", 
        },
        footer: {
            copyright: "USDT国际信用卡管理系统提供技术支持"
        },
        editForm: {
            inputPlaceholder: "请输入",
            selectPlaceholder: "请选择"
        },
        table: {
            total: "共",
            items: "条记录"
        }
    },
    login: {
        title: "USDT国际信用卡管理系统",
        loginBtn: "登录",
        copyright: "USDT国际信用卡管理系统提供技术支持",
        rememberAccount: "记住账号"
    },
    tableColumns: {
        operation: "操作",
        code: "编码",
        fullName: "全称",
        isEnable: "是否启用",
        name: "名称",
        updatedAt: "更新时间",
        regIp: "注册ip",
        lastIp: "最后一次登陆ip",
        lastTime: "最后一次登陆时间",
        CreatedAtString: "创建时间",
        UpdatedAtString: "修改时间",
    },
    page: {
        home: {
            name: '概覽',
        },
        mine: {
            name: "个人中心",
            refresh: "是否刷新邀请码？"
        },
        amount: {
            name: "金额管理",
            auditAt: "审核时间",
            auditManagerId: "审核管理员id",
            commissionFee: "手续费",
            status: "状态",
            status1: "审核中",
            status2: "拒绝",
            status3: "取消",
            status4: "完成",
            remark: "审核备注",
            email: "用户邮箱",
            memberId: "用户Id",
            receivedAmount: "实际到账金额",
            CheckResult: "审核结果",
            CheckResult1: "通过",
            CheckResult2: "驳回",
            walletType: "货币类型",
            walletType1: "usd",
            recharge: {
                name: "充值管理",
                amount: "支付金额",
                managerId: "业务员id",
                memberUsdtAddress: "用户充值地址",
                orderSn: "关联订单号",
                payCallbackStatus: "支付状态",
                payCallbackStatus1: "待审核",
                payCallbackStatus2: "通过",
                randomMantissa: "随机尾数",
                rechargeType: "支付类型",
                rechargeType1: "银行转账",
                rechargeUsdtAddress: "充值到账地址",
                RechargeId: "充值订单id",
                rechargeStatus: "充值状态",
                rechargeStatus1: "待支付",
                rechargeStatus2: "充值中",
                rechargeStatus3: "失败",
                rechargeStatus4: "取消",
                rechargeStatus5: "完成",
            },
            withdrawal: {
                name: "提现管理",
                orderNo: "订单号",
                amount: "提现金额",
                bankId: "提现银行卡id"
            },
            balanceLog: {
                name: "余额日志",
                after: "变更后",
                amount: "变更金额",
                before: "变更前",
                daily: "日期",
                describe: "描述",
                scene: "变动场景",
                track: "出入标识",
                track1: "增加",
                track2: "减少",
                transactionId: "交易id",
                transactionNo: "交易编号",
            },
            userAddress: {
                name: "用户地址"
            }
        },
        card: {
            name: "卡片管理",
            udpayCardBin: "卡bin（卡头）",
            udpayCardScheme: "卡scheme",
            udpayCardLevel: "卡等级",
            udpayModeType: "卡模式",
            udpayProductId: "平台产品id",
            udpayProductStatus: "订单状态",
            memberId: '用户id',
            main: {
                udpayCardStatus: '卡状态',
                cardProductId: '卡产品id',
                udpayCardCurrency: "币种",
                udpayAvailableBalance: "可用余额",
                member: "用户"
            },
            product: {
                name: "卡产品管理",
                status1: "有效",
                status2: "无效",
                async: "同步",
            },
            record: {
                email: "邮箱",
                name: "卡片充提记录",
                fullName: "卡片充值提现记录列表",
                cardId: "卡id",
                amount: "金额",
                commissionFee: "手续费",
                orderNo: "订单号",
                receivedAmount: "实际到账",
                type: "类型",
                udpayCardId: "卡id",
                udpayCardOrderId: "卡订单id",
                udpayOrderStatus: "订单状态",
                udpayOrderType: "订单类型",
                walletType: "货币类型",
                memberCardId: "用户卡id",
                type1: "充值",
                type2: "提现",
            },
            transaction: {
                name: "卡账单（交易记录）",
                authorizationCode: "授权码",
                billingAmount: "账单金额",
                billingCurrency: "计费货币",
                cardAvailableBalance: "卡可用余额",
                failureReason: "失败的原因",
                postedTime: "交易过账时间",
                transactionAmount: "交易金额",
                transactionCurrency: "交易货币",
                transactionFee: "交易费用",
                transactionStatus: "交易状态",
                transactionTime: "交易发生时间",
                transactionType: "交易类型",
                transactionType1: "因卡使用而预留的资金",
                transactionType2: "购买金额退还至账户余额",
                transactionType3: "撤销授权",
                udpayCardId: "卡片Id",
                udpayTransactionId: "交易Id",
                udpayCardholderId: "持卡人Id",
                udpayMaskedCardNumber: "卡号",
                udpayOriginalTransactionId: "原交易Id",
            }
        },
        level: {
            name: "等级管理",
            cardNum: "卡位",
            cardNumTip: "最大在线卡数量，已删除不计入",
            cycle: "会员时长",
            cycleTip: "基数天",
            introduction: "简介",
            level: "等级",
            minRechargeAmount: "最小充值金额",
            title: "名称",
            openCardFee: "开卡费",
            price: "价格",
            serviceRate: "卡服务费率",
            usdRechargeRate: "美金充值费率",
            usdtRechargeRate: "usdt充值费率",
            withdrawRate: "	提现手续费率",
        },
        member: {
            name: "人员管理",
            user: {
                name: "用户管理",
                user: "用户",
                account: "账号",
                agentId: "代理id",
                amount: "默认货币余额",
                amount1: "余额",
                commission: "佣金",
                commissionAll: "累计佣金",
                createdAt: "创建时间",
                email: "邮箱",
                freezeAmount: "冻结金额",
                fundPasswordHash: "资金密码",
                isCanTrade: "是否可交易",
                lastIp: "最后一次登陆ip",
                lastTime: "最后一次登陆时间",
                lever: "杠杆id",
                managerId: "推广业务员id",
                regIp: "代理id",
                type: "用户类型",
                type1: "普通用户",
                type2: "模拟用户",
                updateAmount: "上下分",
                addAmount: "上分",
                reduceAmount: "下分",
                usdAmount: "美元金额",
                FundPassword: "资金密码",
                Password: "密码",
                now: "当前余额",
                after: "之后余额",
                grade: "会员等级",
            },
            manager: {
                name: "管理员管理",
                avatar: "头像",
                inviteCode: "邀请码",
                pid: "上级",
                role: "角色",
                role1: "普通管理员",
                role2: "超级管理员",
                username: "帐号",
                password: "密码",
                manager: "管理员",
                pwd: "更新密码"
            },
            role: {
                name: "角色管理",
                id: "角色Id",
                roleName: "角色名称"
            }
        },
        settings: {
            name: "设置",
            notice: {
                notice: "公告设置",
                config: "配置管理",
                privilege: "权限管理",
                system: "系统管理",
                noticeName: "公告名称",
                IsPop: "是否弹窗",
                display: "显示",
                hidden: "隐藏",
                sort: "排序",
                language: "语言",
                noticeId: "公告id",
                title: "标题",
                noticeS: "公告",
                viewNotice: "查看公告",
                noticeTitle: "公告标题"
            },
            config: {
                name: "配置管理",
                config: "配置",
                cateId: "配置分类",
                mark: "配置标识",
                remark: "配置说明",
                sort: "排序",
                title: "配置标题",
                type: "配置类型",
                value: "配置值",
            },
            privilege: {
                name: "权限设置"
            },
            system: {
                name: "系统设置"
            },
            email: {
                name: "邮件配置"
            }
        },
    }
};
